import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";
import Locale from "@/helper/locale/locale.js";

/**
 * @method apiGetCartCount
 * @method apiGetCartQuantityCount
 * @method apiGetCartList
 * @method apiAddToCart
 * @method apiGetShoppingOrder
 * @method apiPostSubscription
 */
export default {
    /**
     * Get cart's item amount.
     * @param {String} token
     */
    apiGetCartCount: function(token) {
        var url = ConfigManager.getApiShoppingCartUrl() + "/cart/count";
        let params = {
            countQuantity: true
        };
        return BzbsApi.connectBzbsGet(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    /**
     * Get total item's quantity in cart.
     * @param {String} token
     */
    apiGetCartQuantityCount: function(token) {
        return this.apiGetCartList(token).pipe(
            map(data => {
                var total = 0;
                var list = data.list;
                if (list) {
                    for (var items of list) {
                        for (var item of items.items) {
                            total += item.Quantity;
                        }
                    }
                }
                return total;
            })
        );
    },

    /**
     * Get cart's list.
     * @param {String} token
     */
    apiGetCartList: token => {
        var url = ConfigManager.getApiShoppingCartUrl() + "/cart/list_summary";
        return BzbsApi.connectBzbsGet(url, token).pipe(
            map(res => {
                return res.data;
            })
        );
    },

    /**
     * Add item(s) to cart.
     * @param {string} strBzbsToken
     * @param {Object} cartParams /core/ShoppingCart/model/AddCartModel.js
     */
    apiAddToCart: (token, cartParams, campaignId, amount, orderDetail) => {
        var localeCode = Locale.getLocaleCode();
        var objectJson = JSON.stringify(cartParams);
        var params = {
            countQuantity: false,
            campaignId: campaignId,
            sideCampaignJson: objectJson,
            qty: amount,
            remark: orderDetail,
            mode: "add"
        };
        var url =
            ConfigManager.getApiShoppingCartUrl() +
            `/cart/${campaignId}/add?locale=${localeCode}`;
        // console.log(params, token, url)
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    /**
     * @param {string} token
     * @param {AddressListModel} params /core/Address/model/AddressListModel.js
     */
    apiPostSubscription: function(token, params) {
        const url = ConfigManager.getApiShoppingCartUrl() + "/cart/save_subscription_food";
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiGetShoppingOrder: (token, type) => {
        var url =
            ConfigManager.getShippingUrl() +
            `/food/get_upcoming_orders?type=${type}`;
        return BzbsApi.connectBzbsGet(url, token).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiGetCompletedOrder: (token, type) => {
        let url =
            ConfigManager.getShippingUrl() +
            `/food/get_completed_orders?type=${type}`;
        return BzbsApi.connectBzbsGet(url, token).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiGetCancelOrder: token => {
        let params = {
            top: 15,
            statusId: -10
        };
        let url = ConfigManager.getShippingUrl() + `/order/get_orders`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    apiCancelOrder: (token, tranId) => {
        //ui ไม่มีให้กรอกเหตุผล
        let params = {
            tranId: tranId,
            reasonDetail: "เปลี่ยนใจเพราะเจอข้อเสนอที่ดีกว่า",
            reason: "เปลี่ยนใจเพราะเจอข้อเสนอที่ดีกว่า"
        };
        let url = ConfigManager.getShippingUrl() + `/order/cancel_order`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => {
                return res.data;
            })
        );
    }
};
